<template>
<div>
<v-dialog width="450" v-model="init.paramsMod" persistent scrollable>



<v-card style='overflow: hidden'>
<v-card-title style="color:grey"><h4>Параметры фильтра</h4> <v-spacer></v-spacer> <v-icon @click="close()" color="red">mdi-close</v-icon></v-card-title>
<v-divider></v-divider>
<v-card-text>


<slot v-if="this.init.paramsModSelected =='endsOfLastName'">
<v-textarea v-model="filter.filters[0].endsOfLastName.params.ends" label="Укажите окончания фамилий через запятую, например ev,on,ва,оф"></v-textarea>
</slot>

<slot v-if="this.init.paramsModSelected =='isOfflineLots'">
  <v-text-field v-model="filter.filters[0].isOfflineLots.params.howOldDays" type="number" label="Сколько дней офлайн максимум"></v-text-field>
  <v-text-field v-model="filter.filters[0].isOfflineLots.params.howOldHours" type="number" label="Сколько часов офлайн максимум"></v-text-field>
  <v-text-field v-model="filter.filters[0].isOfflineLots.params.howOldMin" type="number" label="Сколько минут офлайн максимум"></v-text-field>
</slot>

<slot v-if="this.init.paramsModSelected =='isPhotosInOneTime'">
<v-text-field v-model="filter.filters[0].isPhotosInOneTime.params.howOldDays" type="number" label="Сколько дней прошло с момента загрузки максимум"></v-text-field>
<v-text-field v-model="filter.filters[0].isPhotosInOneTime.params.howOldHours" type="number" label="Сколько часов прошло с момента загрузки максимум"></v-text-field>
<v-text-field v-model="filter.filters[0].isPhotosInOneTime.params.howOldMin" type="number" label="Сколько минут прошло с момента загрузки максимум"></v-text-field>
<v-range-slider v-model="filter.filters[0].isPhotosInOneTime.params.photoCount" thumb-label="always" min="2" max="200" label="Колличество фото"></v-range-slider>
</slot>

<slot v-if="this.init.paramsModSelected =='isSuspectTraffIds'">
<v-slider style="margin-top:25px" v-model="filter.filters[0].isSuspectTraffIds.params.intCount" thumb-label="always" min="2" max="12" label="Количество первых цифр"></v-slider>
<v-text-field v-model="filter.filters[0].isSuspectTraffIds.params.howMaxMin" type="number" min="1" hint="Количество минут" label="Анализировать промежуток времени в минутах"></v-text-field>
<v-text-field  v-model="filter.filters[0].isSuspectTraffIds.params.intersectMin" type="number" min="2" label="Минимальное число совпадений"></v-text-field>
<v-text-field  v-model="filter.filters[0].isSuspectTraffIds.params.maxValueOfIntersectsToMidPercen" type="number" min="2" label="Во сколько раз может привыситься норма совпадений"></v-text-field>
<v-checkbox color="#232F3A" v-model="filter.filters[0].isSuspectTraffIds.params.onlyOneSrc" hide-details >
<span style="color:#232F3A;margin-top:6px" slot="label">Только один и тот же источник</span>
</v-checkbox>
</slot>

<slot v-if="this.init.paramsModSelected =='isSuspectPublicsIds'">
<v-slider style="margin-top:25px" v-model="filter.filters[0].isSuspectPublicsIds.params.intCount" thumb-label="always" min="2" max="12" label="Количество первых цифр"></v-slider>
<v-text-field  v-model="filter.filters[0].isSuspectPublicsIds.params.intersectMin" type="number" min="2" label="Минимальное число совпадений"></v-text-field>

</slot>

</v-card-text>
<v-card-actions>
<v-spacer></v-spacer>
<v-btn @click="close()" flat small   color="#4A76A8">Отмена</v-btn>
<v-btn @click="save()" small class="white--text" color="#4A76A8">Применить</v-btn>
</v-card-actions>
</v-card>




</v-dialog>
</div>
</template>

<script>
export default {
 props: ['filter','init'],
  data () {
    return {

    }
  },
methods:{
close(){
this.filter.filters[0].[this.init.paramsModSelected].active = false
this.init.paramsMod = false
},
save(){
this.init.paramsMod = false
},
},
}
</script>
